/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_EditInputs */

const vi_customer_group_edit = /** @type {(inputs: Customer_Group_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa nhóm`)
};

/**

* @param {Customer_Group_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_edit = /** @type {((inputs?: Customer_Group_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_edit(inputs)
});